define('KlaviyoNewsletter.EntryPoint', [
  'KlaviyoNewsletter.View'
], function KlaviyoNewsletterEntryPoint(
  KlaviyoNewsletterView
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent('Layout');
      var environmentComponent = container.getComponent('Environment');
      var userprofilecomponent = container.getComponent('UserProfile');
      var klaviyoConfiguration;

      if(layout && environmentComponent) {
        klaviyoConfiguration = environmentComponent.getConfig('KlaviyoFooterSubscription');
        userprofilecomponent.getUserProfile().then(function getUserInfo(profile) {
          layout.addChildView('Monster.Newsletter', function () {
            return new KlaviyoNewsletterView({
              container: container,
              configuration: klaviyoConfiguration,
              profile: profile
            });
          });
        });


      }

    }
  };
});
